import React from 'react'
import {
    Button,
    makeStyles,
} from '@material-ui/core'
import { clsx } from 'clsx';

const linearGradient = "linear-gradient(90deg, #87959C, #89959B, #8B949B, #B1B3BB, #C3C8CC, #F1F2F4, #D2DBE6, #9AB0B7, #A5B7C0 )"
const linearGradientHover = "linear-gradient(90deg, #606067, #A3A4A9, #D5D8E0, #767A7D )"
const linearGradientBackground = "linear-gradient(90deg, #87959C, #89959B, #8B949B, #B1B3BB, #C3C8CC, #F1F2F4 40%, #D2DBE6, #D2DBE6, #9AB0B7, #A5B7C0 )"

const useStyles = makeStyles(() => ({
    outlinedButton: {
        border: " 1px solid transparent",
        borderImage: `${linearGradient} 1`,
        color: '#ffffff',
        textTransform: 'none',
        fontSize: '16px',
        lineHeight: 1,
        padding: "16px 32px",
        "&:hover": {
            borderImage: `${linearGradientHover} 1`,
        }
    },
    containedButton: {
        background: linearGradientBackground,
        backgroundPosition: "left",
        backgroundSize: "100% 100%",
        textTransform: 'none',
        fontSize: '16px',
        lineHeight: 1,
        padding: "16px 32px",
        borderRadius: 0,
        transition: "all 0.3s ease",
        "& .MuiButton-label": {
            color: '#111111',
        },
        "&:hover": {
            backgroundSize: "110% 100%",
        }
    },
    containedPinkButton: {
        background: "linear-gradient(90deg, #CF819D, #FFB8D1, #CF819D)",
        backgroundPosition: "left",
        backgroundSize: "100% 100%",
        textTransform: 'none',
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: 1,
        padding: "16px 32px",
        borderRadius: 0,
        transition: "all 0.3s ease",
        "& .MuiButton-label": {
            color: '#111111',
        },
        "&:hover": {
            backgroundSize: "110% 100%",
        }
    }
}))

interface CustomButtonProps extends React.ComponentPropsWithoutRef<typeof Button> {
    text: string
    styles?: string
}

export const OutlinedButton = ({ text, styles, onClick, ...props }: CustomButtonProps) => {
    const classes = useStyles()
    return (
        <Button
            variant="outlined"
            className={clsx(classes.outlinedButton, styles)}
            onClick={onClick}
            {...props}
        >
            {text}
        </Button>
    )
}

export const ContainedButton = ({ text, styles, onClick, ...props }: CustomButtonProps) => {
    const classes = useStyles()
    return (
        <Button
            variant="contained"
            className={clsx(classes.containedButton, styles)}
            onClick={onClick}
            {...props}
        >
            {text}
        </Button>
    )
}

export const ContainedPinkButton = ({ text, styles, onClick, ...props }: CustomButtonProps) => {
    const classes = useStyles()
    return (
        <Button
            variant="contained"
            className={clsx(classes.containedPinkButton, styles)}
            onClick={onClick}
            {...props}
        >
            {text}
        </Button>
    )
}